<template>
  <div class="about-wrapper">
    <container>
      <div class="about-header">
        <h2 class="about-header__title">Basında Biz</h2>
        <p class="about-header__text">Yurtlarburada.com <span>2006 yılında proje çalışmalarına başlamış, </span> yılının
          Haziran
          ayında yayına girmiş olan, üniversite sınavına girerek kayıt hakkı kazanmış öğrencilere ve
          üniversite öğrencilerine yurtbulma konusunda yardımcı olan, 2013 yılında 941.216 kişi
          ziyaretçiye sahip rehber bir sayfadır.</p>
        <div class="about-header__img">
          <img src="@/assets/img/hakkimizda/about-smile.svg" alt="">
        </div>

      </div>
    </container>

    <div class="about-info">
      <container>
        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/hakkimizda/dom.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>3.510</strong>
            <p>Aktif Yurt</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>

        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/hakkimizda/student.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>3.510</strong>
            <p>Kayıtlı Öğrenci</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>

        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/hakkimizda/visitor.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>1.273.413</strong>
            <p>Yıllık Ziyaretçi</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>

        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/hakkimizda/view.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>4.233.502</strong>
            <p>Görüntülenme</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>
      </container>
    </div>

    <div class="media" id="media">
      <container>
        <div class="media__top">

        </div>
        <div class="section__header">
          <div class="section__title">
            <span class="color-light-green">Basında</span> YurtlarBurada<span class="color-light-green">.com ?</span>
          </div>
        </div>
        <h1 class="media__title">Öncelikle ulusal basının (Sabah,Posta, Milliyet, cnnturk.com , milliyet.com.tr,
          Bugün,Gazeteleri gibi v.s) ve Televizyonların Üniversiteyi
          kazanan öğrencilere yurt bulma konusunda referans gösterdiği tek özel öğrenci yurtları tanıtım
          portalıyız.</h1>
        <div class="media__list">

          <div class="blog-list__item" v-for="(media,index) in mediaList" :key="media.id" @click="dataGo(media,index)">
            <media-card :media="media"/>
          </div>

          <transition name="fade">
          <ImageLightBox :data="MediaArray" v-if="display" @closeLightBox="closeBox"
                         @onClickNext="nextNotice"
                         @onClickPrev="prevNotice"
          />
          </transition>

        </div>
      </container>
    </div>
  </div>
</template>

<script>
import MediaCard from '@/components/MediaCard'
import ImageLightBox from '@/components/ImageLightBox'

export default {
  name: 'About',
  components: {
    MediaCard, ImageLightBox
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Basında Biz',
      link: [
        { rel: 'canonical', href: window.location.origin + '/basinda-biz' }
      ] 
    }
  },   
  data () {
    return {
      display: false,
      IndexNo: null,
      MediaArray: {},
      mediaList: [
        {
          id: 0,
          cover: require('@/assets/img/basin/basin-1.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5b4a9cc0eb10bb2434e7fb69.jpg',
          date: '18 Mart 2018',
          title: 'TRT 1',
          author: 'Muhammed Erdem'
        },
        {
          id: 1,
          cover: require('@/assets/img/basin/basin-2.png'),
          image: 'https://im.haberturk.com/2018/10/19/2183896_05967b8ab6f7a0a0e836443fcca7012b_640x640.jpg',
          date: '18 Mart 2018',
          title: 'Milliyet',
          author: 'Muhammed Erdem'
        },
        {
          id: 2,
          cover: require('@/assets/img/basin/basin-3.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Posta',
          author: 'Muhammed Erdem'
        },
        {
          id: 3,
          cover: require('@/assets/img/basin/basin-1.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'TRT 1',
          author: 'Muhammed Erdem'
        },
        {
          id: 4,
          cover: require('@/assets/img/basin/basin-2.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Milliyet',
          author: 'Muhammed Erdem'
        },
        {
          id: 5,
          cover: require('@/assets/img/basin/basin-1.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'TRT 1',
          author: 'Muhammed Erdem'
        },
        {
          id: 6,
          cover: require('@/assets/img/basin/basin-2.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Milliyet',
          author: 'Muhammed Erdem'
        },
        {
          id: 7,
          cover: require('@/assets/img/basin/basin-2.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Milliyet',
          author: 'Muhammed Erdem'
        },
        {
          id: 8,
          cover: require('@/assets/img/basin/basin-3.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Posta',
          author: 'Muhammed Erdem'
        }
      ]
    }
  },

  methods: {
    dataGo (data, index) {
      this.display = true
      this.MediaArray = data
      this.IndexNo = index
    },
    closeBox () {
      this.display = false
    },
    nextNotice () {
      this.MediaArray = []
      this.IndexNo++
      this.MediaArray = this.mediaList[this.IndexNo]
    },

    prevNotice () {
      this.MediaArray = []
      this.IndexNo--
      this.MediaArray = this.mediaList[ this.IndexNo ]
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/about";
</style>
